import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { ComposedSheet } from '@/components/ui/ComposedSheet'
import { CellContext } from '@tanstack/react-table'
import { RowAction } from '../types-v4'
import { TemplateActivityLog } from './TemplateActivityLog'
import { SheetWithFormComponent } from '@/components/ui/SheetWithFormComponent'
import { useState } from 'react'
import { IconUploadOutline } from '@icons/IconUploadOutline'
import { DynamicIcon } from '@/components/icons/DynamicIcon'

type UploadTemplateItemProps<T, V> = {
  action: RowAction
  info: CellContext<T, V>
}

export function UploadTemplateMenuItem<T, V>({ action, info }: UploadTemplateItemProps<T, V>) {
  const [sheetOpen, setSheetOpen] = useState(false)
  const { entityGUID, templateKey: templateKeyParam } =
    (action.parameter_mappings as Record<'entityGUID' | 'templateKey', string>) || {}
  if (!entityGUID || !templateKeyParam) return null

  const entityGuid = (info.row.original as Record<string, string>)[entityGUID]
  const templateKey = (info.row.original as Record<string, string>)[templateKeyParam]

  return (
    <SheetWithFormComponent
      title="Upload template"
      description="Upload a template for the entity."
      trigger={
        <div onClick={(e) => e.stopPropagation()}>
          <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
            <div className="flex items-center gap-2">
              <DynamicIcon
                iconName={action.icon || ''}
                lazyLoad={false}
                className="size-3"
                fallback={<IconUploadOutline className="size-3" />}
              />
              <span>{action.label}</span>
            </div>
          </DropdownMenuItem>
        </div>
      }
      wide
      isOpen={sheetOpen}
      onOpenChange={setSheetOpen}
    >
      <TemplateActivityLog entityGuid={entityGuid} templateKey={templateKey} />
    </SheetWithFormComponent>
  )
  // return (
  //   <ComposedSheet
  //     wide
  //     trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Upload template</DropdownMenuItem>}
  //     title="Upload template"
  //   >
  //     <TemplateActivityLog entityGuid={entityGuid} templateKey={templateKey} />
  //   </ComposedSheet>
  // )
}
